// extracted by mini-css-extract-plugin
export default {"root":"Eos7MlSM","container":"r8e4WXyV"};